import AwcAutocompleteElement from '@ambiki/impulse-view-components/dist/elements/autocomplete';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    const serviceRateContainer = document.getElementById('service-container');
    const autocompleteServiceRates = serviceRateContainer.querySelector('awc-autocomplete');

    const billToContainer = document.getElementById('bill-container');
    const autocompleteFacilities = billToContainer.querySelector('awc-autocomplete');

    const serviceRatesUrl = $('#service-rates-url').val();
    const facilitiesUrl = $('#facilities-url').val();
    const patientsUrl = $('#patients-url').val();

    $(autocompleteFacilities).on('awc-autocomplete:commit', () => {
      autocompleteServiceRates.setAttribute('src', `${serviceRatesUrl}&facility_id=${autocompleteFacilities.value}`);
      this.updatePatientList(`${patientsUrl}&facility_id=${autocompleteFacilities.value}&by_assigned_facility=true`);
    });

    $(autocompleteFacilities).on('awc-autocomplete:clear', () => {
      autocompleteServiceRates.setAttribute('src', `${serviceRatesUrl}`);
      this.updatePatientList(`${patientsUrl}&by_assigned_facility=true`);
    });

    $(autocompleteServiceRates).on('awc-autocomplete:commit', () => {
      autocompleteFacilities.setAttribute('src', `${facilitiesUrl}&service_rate_id=${autocompleteServiceRates.value}`);
    });

    $(autocompleteServiceRates).on('awc-autocomplete:clear', () => {
      autocompleteFacilities.setAttribute('src', `${facilitiesUrl}`);
    });

    $('#patient-button').on('click', () => {
      setTimeout(() => {
        if (autocompleteFacilities.value) {
          this.updatePatientList(
            `${patientsUrl}&facility_id=${autocompleteFacilities.value}&by_assigned_facility=true`
          );
        } else {
          this.updatePatientList(`${patientsUrl}&by_assigned_facility=true`);
        }
      }, 500);
    });
  }

  updatePatientList(url) {
    const patientsContainers = document.getElementsByClassName('patients-container');
    if (!patientsContainers) return;

    patientsContainers.forEach((patientList) => {
      const autocompletePatients = patientList.querySelector('awc-autocomplete');
      autocompletePatients.setAttribute('src', `${url}`);
    });
  }
}
